// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Managemembes_Linkedinimage__DblHM {
    width: 45px;
    height: 45px;
    margin: 5px 10px;
    align-items: baseline;
    font-size: medium;
  }
  
  .Managemembes_container__iSCTM {
    background-color: #ffffff;
    color: black;
    border-radius: 20px;
    margin-inline: 20px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 10px 0px;
  }
  
  .Managemembes_childimage__1TiIJ {
    display: flex;
    align-items: center;
  }
  
  .Managemembes_communityUsers__m8WkU {
    display: flex;
    justify-content: space-between;
  }
  
  .Managemembes_dropdown__vpHp6 {
    display: flex;
    justify-content: center;
    background-color: #ffffff;
    width: 10%;
    padding-top: 10px;
  }
  
  .Managemembes_link__3FxF- {
    position: relative;
  }
  
  .Managemembes_dlist__SC4Ua {
    display: none;
    position: absolute;
    width: 300px;
    margin-right: -10px;
    padding: 20px 20px;
    right: 2%;
  
    border-radius: 25px;
    background: #ffffff;
  }
  .Managemembes_moderatorList__R1nOF{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      margin-bottom: -15px;
  }
  .Managemembes_blockUserList__7o2Ld{
      margin-left: -13px;
      width: 100%;
      margin-top: -23px;
  }
  .Managemembes_dlist__SC4Ua li {
    display: flex;
    align-items: center;
  }
  
  .Managemembes_link__3FxF-:hover .Managemembes_dlist__SC4Ua {
    text-decoration: none;
    list-style: none;
    display: block;
  
    flex-direction: column;
    /* background: green; */
    /* border: 1px solid red; */
    background: bottom;
    box-shadow: 1px 2px 3px;
    align-items: center;
    padding: 10px 0 10px 20px;
    line-height: 34px;
  }
  .Managemembes_moderatoricons__roscz {
    margin: 0px 8px 0px 12px;
    height: 20px;
    width: 20px;
  }
  .Managemembes_warningIcon__-4EcL{
    margin: 0px 8px 0px 12px;
  }
  
  .Managemembes_avatharuser__FwoaY {
    display: flex;
    align-items: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/Assets/css/Moderator/Managemembes.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;;IAET,mBAAmB;IACnB,mBAAmB;EACrB;EACA;MACI,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,YAAY;MACZ,oBAAoB;EACxB;EACA;MACI,kBAAkB;MAClB,WAAW;MACX,iBAAiB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;;IAEd,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB","sourcesContent":[".Linkedinimage {\r\n    width: 45px;\r\n    height: 45px;\r\n    margin: 5px 10px;\r\n    align-items: baseline;\r\n    font-size: medium;\r\n  }\r\n  \r\n  .container {\r\n    background-color: #ffffff;\r\n    color: black;\r\n    border-radius: 20px;\r\n    margin-inline: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n    padding: 10px 0px;\r\n  }\r\n  \r\n  .childimage {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .communityUsers {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .dropdown {\r\n    display: flex;\r\n    justify-content: center;\r\n    background-color: #ffffff;\r\n    width: 10%;\r\n    padding-top: 10px;\r\n  }\r\n  \r\n  .link {\r\n    position: relative;\r\n  }\r\n  \r\n  .dlist {\r\n    display: none;\r\n    position: absolute;\r\n    width: 300px;\r\n    margin-right: -10px;\r\n    padding: 20px 20px;\r\n    right: 2%;\r\n  \r\n    border-radius: 25px;\r\n    background: #ffffff;\r\n  }\r\n  .moderatorList{\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: flex-start;\r\n      align-items: center;\r\n      height: 100%;\r\n      margin-bottom: -15px;\r\n  }\r\n  .blockUserList{\r\n      margin-left: -13px;\r\n      width: 100%;\r\n      margin-top: -23px;\r\n  }\r\n  .dlist li {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .link:hover .dlist {\r\n    text-decoration: none;\r\n    list-style: none;\r\n    display: block;\r\n  \r\n    flex-direction: column;\r\n    /* background: green; */\r\n    /* border: 1px solid red; */\r\n    background: bottom;\r\n    box-shadow: 1px 2px 3px;\r\n    align-items: center;\r\n    padding: 10px 0 10px 20px;\r\n    line-height: 34px;\r\n  }\r\n  .moderatoricons {\r\n    margin: 0px 8px 0px 12px;\r\n    height: 20px;\r\n    width: 20px;\r\n  }\r\n  .warningIcon{\r\n    margin: 0px 8px 0px 12px;\r\n  }\r\n  \r\n  .avatharuser {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Linkedinimage": `Managemembes_Linkedinimage__DblHM`,
	"container": `Managemembes_container__iSCTM`,
	"childimage": `Managemembes_childimage__1TiIJ`,
	"communityUsers": `Managemembes_communityUsers__m8WkU`,
	"dropdown": `Managemembes_dropdown__vpHp6`,
	"link": `Managemembes_link__3FxF-`,
	"dlist": `Managemembes_dlist__SC4Ua`,
	"moderatorList": `Managemembes_moderatorList__R1nOF`,
	"blockUserList": `Managemembes_blockUserList__7o2Ld`,
	"moderatoricons": `Managemembes_moderatoricons__roscz`,
	"warningIcon": `Managemembes_warningIcon__-4EcL`,
	"avatharuser": `Managemembes_avatharuser__FwoaY`
};
export default ___CSS_LOADER_EXPORT___;
